export default __webpack_public_path__ + "static/media/user.3982efb5.svg";